import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../../../common/js/Utils';

@Pipe({ name: 'casCurrency' })
export class CasCurrencyPipe implements PipeTransform {
  transform(value: number | string, decimals: number = 2, dollarSign: boolean = true): string {
    return Utils.formatCurrency(value, decimals, dollarSign);
  }
}
